<!-- src/views/NotFound.vue -->
<template>
  <div class="not-found">
    <h1>404 - Page not found</h1>
  </div>
</template>
